export const UPDATE_LIST_RIBBON = 'UPDATE_LIST_RIBBON'
export const UPDATE_PAGE_YOUTUBE = 'UPDATE_PAGE_YOUTUBE'
export const UPDATE_SEARCH = 'UPDATE_SEARCH'
export const UPDATE_HISTORY = 'UPDATE_HISTORY'
